import React, { useState, useEffect, useRef } from 'react';
// import IntlTelInput from 'react-intl-tel-input';
// import 'react-intl-tel-input/dist/main.css';
import axios from 'axios'
import Select, { components } from 'react-select';
// import PhoneInput from 'react-phone-input-2'
// import 'react-phone-input-2/lib/material.css'
// import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

// import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-input-2'
import flags from 'react-phone-number-input/flags'
import { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import { useForm, Controller } from "react-hook-form";
import { deleteCookie, updateCookie } from '../../utility/cookies';
import { getCookie } from '../../utility/cookies';
import { btoa } from '../../../cryptographic/crypto';
import { timeZones, countryPhoneDigits} from "../../utility/constants"
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// import { isPlatform } from '@ionic/react';

const api = process.env.REACT_APP_API_CHAT_BASE_URL

function LeaveMessage({ prefLang, messageInfo, openBot, setOpenBot, setNoFeedback, setPrefLang, chatIsClose, closeChatEff, setChatIsClose, setCloseChatEff, setCloseFloat, setIsLang, setFormRequested, botInfo, socket, teams, setStartChat, setLeaveMessage, leaveMessage, setOpenFeedback, openFeedback, noFeedback, title,message }) {
    const [leaveMsgLoad, setLeaveMsgLoad] = useState(false)
    const [phoneValid, setPhoneValid] = useState(true)
    // const inputRef = useRef(null);
    // const inputRef2 = useRef(null);
    const inputRef3 = useRef(null);
    const inputRef4 = useRef(null);
    const inputRef5 = useRef(null);
    const phoneInputDummy = useRef(null)

    const closeChatFromFeedback = () => {
        socket.emit(btoa(["close-chat", {}]));
        setFormRequested(false)
        updateCookie('appState', 'closeChat')
        updateCookie('appState', 'hasFeedback')
    }

    const [submitComment, setSubmitComment] = useState(false)
    const [nameValue, setNameValue] = useState('')
    const [emailValue, setEmailValue] = useState('')
    const [countryCodeValue, setCountryCodeValue] = useState('')
    const [phoneValue, setPhoneValue] = useState('')
    const [departmentValue, setDepartmentValue] = useState('')
    const [queryValue, setQueryValue] = useState('')
    const [respSuccess, setRespSuccess] = useState(null);
    const [respMsg, setRespMsg] = useState(null)
    const currentLang = getCookie('prefLang')
    const [dialCode, setDialCode] = useState('91')

    const { register, formState: { errors }, handleSubmit, reset, control, setValue, getValues, clearErrors, watch } = useForm();
    console.log("print error", errors)
    useEffect(() => {

        clearErrors();
    }, [leaveMessage])

    useEffect(() => {
        if (messageInfo?.otherProperty?.fullName) {
            setNameValue(messageInfo?.otherProperty?.fullName)
            setValue("name", messageInfo?.otherProperty?.fullName)
        }
        else if (messageInfo?.firstName) {
            setNameValue(messageInfo?.firstName)
            setValue("name",messageInfo?.firstName)
        }
        else {
            setNameValue('')
            setValue("name","")
        }
        if (messageInfo?.otherProperty?.phoneNumber) {
            setPhoneValue(messageInfo?.otherProperty?.phoneNumber)
            setValue("phone",messageInfo?.otherProperty?.phoneNumber)
        }
        else if (messageInfo?.phone) {
            setPhoneValue(messageInfo?.phone)
            setValue("phone",messageInfo?.phone)
        }
        else {
            setPhoneValue('')
            setValue("phone","")
        }
        if (messageInfo?.otherProperty?.emailAddress) {
            setEmailValue(messageInfo?.otherProperty?.emailAddress)
            setValue("email",messageInfo?.otherProperty?.emailAddress)
        }
        else if (messageInfo?.email) {
            setEmailValue(messageInfo?.email)
            setValue("email",messageInfo?.email)
        }
        else {
            setEmailValue('')
            setValue("email","")
        }
    }, [])
    const [teamsArr, setTeamsArr] = useState([])
    useEffect(() => {
        const fetchCountry = () => {
            fetch('http://ip-api.com/json')
                .then(function (response) {
                    return response.json();
                })
                .then(function (payload) {
                    setCountryCodeValue(payload?.countryCode)
                });
        }

        fetchCountry()
        const getDept = () => {
            let team = [];
            teams?.map(dept => {
                // setTeamsArr([...teamsArr, { value:dept.payload, label:dept.title}])
                team.push({ value: dept.payload, label: dept.title })
            })

            if(teams?.length === 1){
                // console.error(teams, "teams 121")
                setValue("department", teams[0]?.payload)
                setDepartmentValue(teams[0]?.payload)
            }
            setTeamsArr(team)
        }
        getDept()

        // setPhoneValue(messageInfo?.otherProperty?.phoneNumber ? messageInfo?.otherProperty?.phoneNumber : messageInfo?.phone ? messageInfo?.phone)
    }, [])

    const emailChange = (val) => {
        setEmailValue(val)
    };
    const nameChange = (e) => {
        setNameValue(e)
    };

    const validatePhoneNumber = (value) => {
        const phoneNumber = value?.slice(String(dialCode)?.length);
        if (phoneNumber?.length > 0) {
            const country = countryPhoneDigits.filter(item => item.code === dialCode) ;
            const expectedDigits = country?.length ? country[0].digits : 10;
            if (phoneNumber.replace(/\D/g, '').length !== expectedDigits) {
                return `Phone number must be ${expectedDigits} digits long for ${country[0].country}.`;
            }
            return true;  
        }else{
            return true;  
        }
    };

    const leaveMegSubmit = (data) => {
        console.log(data, "data 133")
        setLeaveMsgLoad(true)
        let object = {
            name: nameValue,
            email: emailValue,
            phone: phoneValue,
            department: departmentValue,
            message: queryValue,
            group_id: localStorage.getItem("groupId") ? localStorage.getItem("groupId") : botInfo?.data?.group?.id,
            "customer_id": message?.customerId?.Id,
            "conversation_id": message?.conversationId?.Id,
            "bot_name": botInfo?.data?.bot?.nickName
        }
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        if(botType === "TlkDocs"){
            object.session_id = window.sessionId
        }else{
            object.session_id = getCookie('sessionId') ? getCookie('sessionId') : ""
        }
        console.log(object, "data 134")

        axios
        .post(`${api}api/1.0.0/leaveAMessage`, object)
        .then((response) => {
            // setBotInfo(response.data);
            // console.log("print the res", response)
            if(response.data.success === 0 ){
                setRespSuccess(response.data.success)
                setRespMsg(response.data.message)
            }
            else if(response.data.success === 1){
                setSubmitComment(true)
            }

        })
    }

    const [maxInput, setMaxInput] = useState(20)
    const HandleMaxInputLength=(val, countyCode)=>{
        // console.error(val, "val90")
        if(countyCode === "27"){
            const country = countryPhoneDigits.filter(item => item.code === countyCode) ;
            const expectedDigits = country?.length ? country[0].digits : 10;
            let inputLength = countyCode?.length + expectedDigits + 4
            setMaxInput(inputLength)
        }else{
            setMaxInput(20)
        }
    }

    const [isIonicApp, setIsIonicApp] = useState(false);

    useEffect(() => {
        if (window.Capacitor || window.Ionic) {
            const isMobileDevice = /android|iphone|ipod|ipad/i.test(navigator.userAgent);
            if (isMobileDevice) {
                setIsIonicApp(true);
            } else {
                setIsIonicApp(true);
            }
        } else {
            setIsIonicApp(false);
        }
    }, []);
    
    const [currInput, setCurrInput] = useState("")
    const handleFocus = (refKey) => {
        let inputTarget = document.getElementById(refKey)
        if (isIonicApp) {
            if(currInput === refKey){
                setTimeout(() => {
                    inputTarget.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 500);
            }else{
                setCurrInput(refKey)
                inputTarget?.blur();
                setTimeout(() => {
                    inputTarget?.focus();
                    setTimeout(() => {
                        inputTarget.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }, 500);
                }, 300);
            }
        }
    };

    const handlePhoneFocus = (id) => {
        let inputRef2 = document.getElementById(id)
        if (inputRef2 && isIonicApp) {
            if(currInput === id){
                setTimeout(() => {
                    inputRef2.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 500);
            }else{
                setCurrInput(id)
                inputRef2.blur();
                setTimeout(() => {
                    inputRef2.focus();
                    setTimeout(() => {
                        inputRef2.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }, 500);
                }, 300);
            }
        }
    };

    const handleSelectFocus =()=>{
        let inputRef5 = document.getElementById("inputRef5")
        if (inputRef5 && isIonicApp) {
            inputRef5.blur();
            phoneInputDummy.click()
            setTimeout(() => {
                inputRef5.focus();
                setTimeout(() => {
                    inputRef5.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 500);
            }, 500);
        }
    }

    const customComponents = {
        Control: ({ children, innerRef, innerProps }) => (
        <div
            // id="inputRef5"
            {...innerProps}
            className="custom-control-select"
            // onClick={handleSelectFocus}  // Attach the click handler here
        >
            {children}
        </div>
        ),
    };



    const currentCountry = timeZones[Intl.DateTimeFormat().resolvedOptions().timeZone] !== undefined ? timeZones[Intl.DateTimeFormat().resolvedOptions().timeZone] : "in"
    return (
        <>
            {
                leaveMessage ?
                    <div className="drawer-overlay" onClick={() => setLeaveMessage(false)}></div>
                    : null
            }
            <div className={`leave-message-wrapper ${leaveMessage ? "show-leave-form" : ""}`}>
                <div className="green-mark"></div>
                <HighlightOffIcon className="closebar-toggler" onClick={() => setLeaveMessage(false)} />
                {/* <img src={CloseBar} className="closebar-toggler" alt="closebar toggler" onClick={() => setLeaveMessage(false)} /> */}
                <div className="drawer-header">
                    {
                        submitComment ?
                            botInfo?.data?.mobileAppConfig?.thankYou ? botInfo?.data?.mobileAppConfig?.thankYou?.[prefLang] : "Thank You!"
                            : title ? title : botInfo?.data?.mobileAppConfig?.leaveMesssage ? botInfo?.data?.mobileAppConfig?.leaveMesssage?.[prefLang] : "Leave a Message"
                    }
                </div>
                <div className="drawer-body">
                    <div ref={phoneInputDummy}></div>
                    {
                        submitComment ?
                            <div className="comment-thanku-wrapper">
                                <i className="bot icon-thumbs-up"></i>
                                <p>{botInfo?.data?.mobileAppConfig?.step40 ? <span className="has-html" dangerouslySetInnerHTML={{ __html: botInfo?.data?.mobileAppConfig?.step40?.[prefLang] }}></span> : "We appreciate your paitence, someone from our support team will reach you out for your query."}</p>
                                <div className="leave-btn-wrapper thankyou-btn-wrapper">
                                    <button type="button" className="btn-outline" onClick={() => setLeaveMessage(false)}>{botInfo?.data?.mobileAppConfig?.talkkTo ? botInfo?.data?.mobileAppConfig?.talkkTo?.[prefLang] + " " + botInfo?.data?.bot?.nickName : `Talk to ${botInfo?.data?.bot?.nickName}`}</button>
                                    <button type="button" className="btn-default btn-rounded-full" onClick={closeChatFromFeedback}>{botInfo?.data?.mobileAppConfig?.step42 ? botInfo?.data?.mobileAppConfig?.step42?.[prefLang] : "I am done"}</button>
                                </div>
                            </div>
                            :
                            <div className="comment-form-wrapper">
                                <form onSubmit={handleSubmit(leaveMegSubmit)}>
                                    <div className='leavemsg-inner-forn'>
                                    <div className="message-form-group">
                                        <input type="text" className="form-control" id={`lminput1${message?.id}`}
                                            placeholder={botInfo?.data?.mobileAppConfig?.fullName ? botInfo?.data?.mobileAppConfig?.fullName?.[prefLang] : 'Full Name'}
                                            value={nameValue ? nameValue : ''}
                                            // defaultValue = {nameValue} 
                                            // value={nameValue ?? ""}
                                            {
                                            ...register("name", { required: true, onChange: (e) => nameChange(e.target.value) })

                                            }
                                            onClick={()=> handleFocus(`lminput1${message?.id}`)}
                                        />
                                        {
                                            errors.name?.type === 'required' && <p className='error'>{botInfo?.data?.mobileAppConfig?.validName ? botInfo?.data?.mobileAppConfig?.validName?.[prefLang] : "Enter a valid name."}</p>}

                                    </div>
                                    <div className="message-form-group form-group" onClick={()=> handlePhoneFocus(`phoneInput${message?.id}`)}>
                                        <>
                                            <Controller
                                                name="phone"
                                                control={control}
                                                rules={{
                                                    required: {
                                                        value: true, 
                                                        message: "Phone number is required."
                                                    },
                                                    validate: validatePhoneNumber,
                                                }}
                                                render={({ field: { onChange, phone } }) => (
                                                    <PhoneInput
                                                        international
                                                        value={phoneValue}
                                                        enableSearch={true}
                                                        countryCodeEditable={false}
                                                        onChange={(e, country) => {
                                                            setPhoneValue(e)
                                                            setDialCode(country.dialCode)
                                                            HandleMaxInputLength(e,country.dialCode)
                                                            if (e.length > 2) {
                                                                onChange(e);
                                                            } else {
                                                                onChange("");
                                                            }
                                                        }}                                                        

                                                        inputProps={{
                                                            maxLength: maxInput,
                                                            id: `phoneInput${message?.id}`,
                                                        }}

                                                        country={currentCountry}
                                                        id="phone-input"
                                                    />
                                                )}
                                            />
                                            {errors["phone"] && (
                                                <p className="error">{errors["phone"]?.message ? errors["phone"]?.message : "Invalid Phone Number"}</p>
                                            )}
                                        </>
                                    </div>
                                    <div className="message-form-group">
                                        <input type="text" className="form-control"
                                            placeholder={botInfo?.data?.mobileAppConfig?.email ? botInfo?.data?.mobileAppConfig?.email?.[prefLang] : 'Your Email'}
                                            value={emailValue ? emailValue : ''} id={`lminput3${message?.id}`}
                                            {...register("email", {
                                                required: true, pattern: {
                                                    value: /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/g,
                                                    message: 'Email Id is invalid'
                                                },
                                                onChange: (e) => { emailChange(e.target.value) }
                                            })} 
                                            onClick={()=> handleFocus(`lminput3${message?.id}`)} />
                                        {
                                            errors.email?.type === 'required' && <p className='error'>{botInfo?.data?.mobileAppConfig?.emailValidationWeb ? botInfo?.data?.mobileAppConfig?.emailValidationWeb?.[prefLang] : 'Email id is required'}</p>
                                        }
                                        {
                                            errors.email?.type === 'pattern' && <p className='error'>Email ID is invalid</p>}

                                    </div>
                                    <div className="" style={{ marginBottom: '20px' }} 
                                    // onClick={()=> handleSelectFocus()}
                                    >
                                        {teamsArr?.length === 1    ?
                                            <input type='text' className='form-control' value={teamsArr[0]?.label} disabled />
                                        :
                                            <Controller
                                            name="department"
                                            control={control}
                                            // defaultValue=''
                                            rules={{ required: true }}
                                            render={({ field }) => {
                                                return (<Select
                                                    openMenuOnFocus={true}
                                                    value={teamsArr?.filter(d=> d.value === field.value)?.length ? teamsArr?.filter(d=> d.value === field.value)[0] : ""}
                                                    placeholder={botInfo?.data?.mobileAppConfig?.selectDepartment ? botInfo?.data?.mobileAppConfig?.selectDepartment?.[prefLang] : 'Select Department'} options={teamsArr} onChange={(e) => { field.onChange(e.value); setDepartmentValue(e.value) }} 
                                                    components={customComponents}>
                                                </Select>
                                                );
                                            }}
                                        />}
                                        {
                                            errors.department?.type && <p className='error'>{botInfo?.data?.mobileAppConfig?.deptValidation ? botInfo?.data?.mobileAppConfig?.deptValidation?.[prefLang] : "Department is required"}</p>
                                        }
                                    </div>
                                    <div className="message-form-group">
                                        <textarea className="form-control" placeholder={botInfo?.data?.mobileAppConfig?.step45 ? botInfo?.data?.mobileAppConfig?.step45?.[prefLang] : "Query/Message"} row="3"  {...register("message", { required: true, onChange: (e) => { setQueryValue(e.target.value); } })} 
                                        onClick={()=> handleFocus(`inputRef4${message?.id}`)} id={`inputRef4${message?.id}`}
                                        />
                                        {
                                            errors.message?.type && <p className='error'>{botInfo?.data?.mobileAppConfig?.messageValidationWeb ? botInfo?.data?.mobileAppConfig?.messageValidationWeb?.[prefLang] : 'Message is required'}</p>
                                        }
                                    </div>
                                    </div>
                                    <div className="form-action-group">
                                        <button className="btn btn-default btn-rounded-full"> {leaveMsgLoad === true ? "Loading.." : botInfo?.data?.mobileAppConfig?.submit ? botInfo?.data?.mobileAppConfig?.submit?.[prefLang] : "Submit"} </button>
                                        {respSuccess === 0 && <p className='error'>{respMsg}</p>}
                                    </div>
                                </form>
                            </div>
                    }
                </div>
            </div>
        </>
    )
}
export default LeaveMessage;
